import React from "react";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import ButtonV2 from "shared/ui/ButtonV2/ButtonV2.js";
import IntInput from "../intInput/intInput.js";
import LabeledSelect from "../labeledSelect/labeledSelect.js";
import DeleteButton from "../deleteButton/deleteButton.js";
import GreyInfo from "../greyInfo/greyInfo.js";
import { constant, tierCountScopeNames, tierUpperBounds, validateTiers, } from "./priceModes.js";
import * as styles from "./TiersTable.module.css";
const scopeHelp = {
    line: "Progi liczone są osobno dla każdego zdjęcia.",
    "category-format": "Progi liczone są dla wszystkich sztuk tego formatu zamówionych w kategorii. Sztuki zamówione wcześniej zajmują pierwsze progi.",
    "category-all": "Progi liczone są dla sztuk wszystkich formatów zamówionych w kategorii. Sztuki zamówione wcześniej zajmują pierwsze progi.",
};
/**
 * Editor of price tiers with constant prices, e.g. first 3 items free, then 5 zł per item
 */
export default function TiersTable(props) {
    var _a, _b;
    const { provider, onChange, allowCategoryScope } = props;
    const [animationParent] = useAutoAnimate();
    const scope = (_a = provider.countScope) !== null && _a !== void 0 ? _a : "line";
    const bounds = tierUpperBounds(provider.tiers);
    const lastBound = (_b = bounds.at(-1)) !== null && _b !== void 0 ? _b : 0;
    const error = validateTiers(provider.tiers);
    const scopeOptions = Object.keys(tierCountScopeNames)
        .filter((s) => allowCategoryScope || s === "line" || s === scope)
        .map((s) => ({ value: s, label: tierCountScopeNames[s] }));
    function updateTiers(newBounds, prices) {
        onChange({
            ...provider,
            tiers: newBounds.map((bound, index) => {
                var _a;
                return ({
                    next: bound - ((_a = newBounds[index - 1]) !== null && _a !== void 0 ? _a : 0),
                    price: constant(prices[index]),
                });
            }),
        });
    }
    const prices = provider.tiers.map((tier) => tier.price.value);
    return (React.createElement("div", { className: styles.tiers },
        scopeOptions.length > 1 && (React.createElement(LabeledSelect, { label: "Licz sztuki", options: scopeOptions, state: scopeOptions.findIndex((o) => o.value === scope), disableChangeEventOnFirstRender: true, disableExtraSpacing: true, extraWidth: true, onChange: (newScope) => onChange({ ...provider, countScope: newScope }) })),
        React.createElement(GreyInfo, { size: "small" }, scopeHelp[scope]),
        React.createElement("table", { className: styles.table },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Sztuki"),
                    React.createElement("th", null, "Cena za sztuk\u0119 (z\u0142)"),
                    React.createElement("th", null))),
            React.createElement("tbody", { ref: animationParent },
                provider.tiers.map((tier, index) => (React.createElement("tr", { key: index },
                    React.createElement("td", null,
                        React.createElement("div", { className: styles.range },
                            React.createElement("span", null,
                                index === 0 ? 1 : bounds[index - 1] + 1,
                                " \u2013"),
                            React.createElement(IntInput, { state: bounds[index], disableExtraSpacing: true, onChange: (newBound) => updateTiers(bounds.map((b, i) => (i === index ? newBound : b)), prices) }))),
                    React.createElement("td", null,
                        React.createElement(IntInput, { state: tier.price.value, disableExtraSpacing: true, onChange: (newPrice) => updateTiers(bounds, prices.map((p, i) => (i === index ? newPrice : p))) })),
                    React.createElement("td", null,
                        React.createElement(DeleteButton, { onClick: () => updateTiers(bounds.filter((_, i) => i !== index), prices.filter((_, i) => i !== index)) }))))),
                React.createElement("tr", { key: "rest" },
                    React.createElement("td", null, provider.tiers.length === 0 ?
                        "Każda sztuka"
                        : `${lastBound + 1} i kolejne`),
                    React.createElement("td", null,
                        React.createElement(IntInput, { state: provider.priceForAllNext.value, disableExtraSpacing: true, onChange: (newPrice) => onChange({ ...provider, priceForAllNext: constant(newPrice) }) })),
                    React.createElement("td", null)))),
        error && React.createElement("div", { className: styles.error }, error),
        React.createElement(ButtonV2, { variant: "ghost", disableExtraSpacing: true, className: styles.add, onClick: () => updateTiers([...bounds, lastBound + 5], [...prices, provider.priceForAllNext.value]) }, "+ Dodaj pr\u00F3g")));
}
